var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#04245C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 16.6667H8.28333L14.8 10.15L13.85 9.2L7.33333 15.7167V16.6667ZM6 18V15.1667L14.8 6.38333C14.9333 6.26111 15.0807 6.16667 15.242 6.1C15.4033 6.03333 15.5727 6 15.75 6C15.9273 6 16.0996 6.03333 16.2667 6.1C16.4338 6.16667 16.5782 6.26667 16.7 6.4L17.6167 7.33333C17.75 7.45556 17.8473 7.6 17.9087 7.76667C17.97 7.93333 18.0004 8.1 18 8.26667C18 8.44444 17.9696 8.614 17.9087 8.77533C17.8478 8.93667 17.7504 9.08378 17.6167 9.21667L8.83333 18H6ZM14.3167 9.68333L13.85 9.2L14.8 10.15L14.3167 9.68333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.77590bf6b44a03e82ad096a4c4052b88.svg";
export { ForwardRef as ReactComponent };